import WORK_DIALOG_SIZES from '@/components/base_components/dialog/components/enums/WORK_DIALOG_SIZES';

const DIALOG_DEFAULT_WIDTHS = Object.freeze({
  LARGE_AND_UP: {
    [WORK_DIALOG_SIZES.EXTRA_SMALL]: 15,
    [WORK_DIALOG_SIZES.SMALL]: 30,
    [WORK_DIALOG_SIZES.MEDIUM]: 45,
    [WORK_DIALOG_SIZES.LARGE]: 60,
    [WORK_DIALOG_SIZES.EXTRA_LARGE]: 75,
    [WORK_DIALOG_SIZES.FULL_SIZE]: 100,
  },
  MEDIUM: {
    [WORK_DIALOG_SIZES.EXTRA_SMALL]: 30,
    [WORK_DIALOG_SIZES.SMALL]: 45,
    [WORK_DIALOG_SIZES.MEDIUM]: 60,
    [WORK_DIALOG_SIZES.LARGE]: 75,
    [WORK_DIALOG_SIZES.EXTRA_LARGE]: 90,
    [WORK_DIALOG_SIZES.FULL_SIZE]: 100,
  },
  SMALL: {
    [WORK_DIALOG_SIZES.EXTRA_SMALL]: 45,
    [WORK_DIALOG_SIZES.SMALL]: 60,
    [WORK_DIALOG_SIZES.MEDIUM]: 75,
    [WORK_DIALOG_SIZES.LARGE]: 95,
    [WORK_DIALOG_SIZES.EXTRA_LARGE]: 98,
    [WORK_DIALOG_SIZES.FULL_SIZE]: 100,
  },
  EXTRA_SMALL: 98
});

export default DIALOG_DEFAULT_WIDTHS;
